// extracted by mini-css-extract-plugin
export default {"answers":"styles_answers__GPmbw","answer":"styles_answer__Cwjpn","questionLabel":"styles_questionLabel__WHww2","answerText":"styles_answerText__SDx+r"};